import React from 'react';
import FocusTrap from 'focus-trap-react';
import { Portal } from 'react-portal';
import { CloseButton } from './CloseButton';
import styles from './styles.module.scss';

type ModalOverlayProps = {
    onClose: () => void;
    show: boolean;
};

export const ModalOverlay: React.FC<ModalOverlayProps> = ({ children, onClose, show }) => {
    if (!show) {
        return null;
    }
    return (
        <Portal>
            <FocusTrap
                onKeyDown={(event) => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        onClose();
                    }
                }}
            >
                <div className={styles.modal} onClick={onClose} tabIndex={-1} role='dialog'>
                    <div className={styles.modalOverlay} />
                    <div className={styles.modalContainer}>
                        <div className={styles.modalContainerTable}>
                            <div className={styles.modalContainerTableCell}>
                                <div className={styles.modalContainerContent}>
                                    <div className={styles.modalClose}>
                                        <CloseButton onClick={onClose} />
                                    </div>
                                    <div className={styles.modalContent}>
                                        <div className={styles.topRow}>
                                            <div className={styles.inner} />
                                        </div>
                                        <div className={styles.contentRow}>
                                            <div className={styles.contentRowContent}>{children}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FocusTrap>
        </Portal>
    );
};
